const GitlabIcon = () => (
    <svg viewBox="0 0 35 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.364 32.008l6.386-19.654h-12.772l6.386 19.654z" />
        <path d="M17.364 32.008l-6.386-19.654h-8.95l15.336 19.654z" />
        <path d="M2.028 12.354l-1.941 5.973c-0.041 0.122-0.065 0.263-0.065 0.409 0 0.438 0.213 0.826 0.541 1.067l0.004 0.003 16.797 12.203-15.336-19.654z" />
        <path d="M2.028 12.354h8.95l-3.846-11.838c-0.198-0.609-1.060-0.609-1.257 0l-3.846 11.838z" />
        <path d="M17.364 32.008l6.386-19.654h8.95l-15.336 19.654z" />
        <path d="M32.7 12.354l1.941 5.973c0.041 0.122 0.065 0.262 0.065 0.409 0 0.438-0.213 0.826-0.541 1.067l-0.004 0.003-16.796 12.203 15.336-19.654z" />
        <path d="M32.7 12.354h-8.95l3.846-11.838c0.198-0.609 1.060-0.609 1.257 0l3.846 11.838z" />
    </svg>
);

export default GitlabIcon;
